module.exports = __webpack_public_path__ + "static/media/pattern1.9a88cc28.png";